import { useState } from 'react'
import { postJob, employerZone } from '../../../api'
import Navbar from './../components/Navbar'
import  Footer from '../components/Footer'

function FillVacancy() {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  
  const initialData = {
    name: "",
    company: "",
    contact: "",
    email: "",
    desc:"",
  }

  const [formData, setFormData] = useState(initialData)

  const handleSubmit = async (event)=>{
    event.preventDefault();
    setIsSubmitting(true)
    try {
      const { data } = await employerZone(formData);
      console.log("Data", data)
      if (data.success){
        alert("Success")
        setFormData(initialData)
        setErrorMessage("")
      } else {
        setErrorMessage("Error submitting the form, please check the inputs")
        setIsSubmitting(false)
      }
    } catch (error) {
      setErrorMessage("Error submitting the form, please check the inputs")
      setIsSubmitting(false)
    }
  }

  const handleChange = (event)=>{
    const {name, value, type} = event.target
    setFormData(prevFormData => {
      return {
        ...prevFormData,
        [name]: value
      }
    })

  }

  return (
    <>
      <Navbar/>
      <main className="container">
        <div className="formBox">
          <h2>Tell Us about your Requirment</h2>
          <form className="jobResumeForm" onSubmit={handleSubmit}>
            <div className='formItem'>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  name='name'
                  value={formData.Name}
                  onChange={handleChange}
                  required
                />
            </div>
            <div className='formItem'>
              <label htmlFor="company">company-Name</label>
                <input
                  type="text"
                  name='company'
                  value={formData.company_name}
                  onChange={handleChange}
                  required
                />
            </div>
            <div className="formFlex">
                <div className='formItem contact'>
                    <label htmlFor="contact">Contact Number</label>
                    <input
                      type="tel"
                      pattern="^\d{10}$"
                      name='contact'
                      value={formData.contactNo}
                      onChange={handleChange}
                      required
                      />
                </div>
                <div className='formItem email'>
                    <label htmlFor="email">mail-id</label>
                    <input
                      type="email"
                      name='email'
                      value={formData.mailId}
                      onChange={handleChange}
                      required
                      />
                </div>
            </div>
            <div className='formItem'>
                <label htmlFor="desc">Description</label>
                <textarea
                  name="desc" id="" cols="30" rows="10"
                  value={formData.description}
                  onChange={handleChange}
                required
                />
            </div>

            <button type='submit' className='submitbtn'>SUBMIT</button>
            {(errorMessage) && <div style={{color: "red"}} className="message__error grid-full">{errorMessage}</div>}
          </form>
        </div>
      </main>
      <Footer />
    </>
  )
}

export default FillVacancy
